import api from "../../services/api";

export const getCertificates =  ( { page } ) => {
    return  api(`/certificates?page=${page}`)
}
